'use client';

import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from 'react';
import { SubSectionTitle } from '@/components/common/SubSectionTitle';
const VaultPerformanceLayout = t0 => {
  const $ = _c(4);
  const {
    children,
    testId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SubSectionTitle>Returns</SubSectionTitle>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children || $[2] !== testId) {
    t2 = <div className="gap-2xs flex w-[100%] flex-col items-start" data-testid={testId}>{t1}{children}</div>;
    $[1] = children;
    $[2] = testId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default VaultPerformanceLayout;